import PropTypes from 'prop-types'
import React from 'react'

import getClassStyle from '@/checkout-instore-legacy/utils/getClassStyle'
import noop from 'lodash/noop'

function luminanace(r, g, b) {
  const a = [r, g, b].map(function (v) {
    v /= 255
    return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4)
  })
  return a[0] * 0.2126 + a[1] * 0.7152 + a[2] * 0.0722
}

function contrast(rgb1, rgb2) {
  const l1 = luminanace(rgb1[0], rgb1[1], rgb1[2]) + 0.05
  const l2 = luminanace(rgb2[0], rgb2[1], rgb2[2]) + 0.05
  return Math.max(l1, l2) / Math.min(l1, l2)
}

function getRGB(str) {
  const match = str.match(
    /rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/
  )
  return match
    ? {
        red: match[1],
        green: match[2],
        blue: match[3],
      }
    : {}
}

function SummaryCard({
  title,
  number,
  content,
  onClick,
  active,
  hover,
  disabled,
}) {
  const backgroundClass = active ? 'c-action-secondary' : 'c-on-base--inverted'
  const backgroundColor = getClassStyle(backgroundClass, 'color')
  const baseInvertedColor = getClassStyle('c-on-base--inverted', 'color')
  const baseColor = getClassStyle('c-on-base', 'color')

  const { red: rBK, green: gBK, blue: bBK } = getRGB(backgroundColor)
  const { red: rBC, green: gBC, blue: bBC } = getRGB(baseColor)
  const { red: rBI, green: gBI, blue: bBI } = getRGB(baseInvertedColor)

  const invertedContrast = contrast([rBK, gBK, bBK], [rBI, gBI, bBI])
  const baseContrast = contrast([rBK, gBK, bBK], [rBC, gBC, bBC])
  const textColor =
    baseContrast >= invertedContrast ? 'c-on-base' : 'c-on-base--inverted'
  const handleOnClick = disabled ? noop : onClick
  return (
    <div
      className={`flex flex-row items-center ${textColor} ma3 br2 ${
        hover ? 'pointer' : ''
      }`}
      style={{
        backgroundColor: backgroundColor,
        minHeight: '72px',
      }}
      onClick={handleOnClick}
    >
      <div className="self-start z-2">
        <div
          className={`${
            active
              ? 'c-on-base-inverted'
              : disabled
              ? 'c-muted-2'
              : 'c-action-primary'
          } flex items-center justify-center ba bw1 br-pill ml5 mr3`}
          style={{ width: '24px', height: '24px', marginTop: '14px' }}
        >
          <span id="summary-card-number" className="f5 fw4">
            {number}
          </span>
        </div>
      </div>
      <div className="flex flex-column mv2">
        <div
          id="summary-card-title"
          className={`${
            active ? textColor : disabled ? 'c-muted-2' : 'c-action-primary'
          } fw5 f5`}
        >
          {title}
        </div>
        <div
          id="summary-card-content"
          className={`${active ? textColor : 'c-muted-2'} f6 mt2`}
        >
          {content}
        </div>
      </div>
    </div>
  )
}

SummaryCard.defaultProps = {
  hover: true,
}

SummaryCard.propTypes = {
  title: PropTypes.string.isRequired,
  number: PropTypes.number.isRequired,
  content: PropTypes.node,
  onClick: PropTypes.func,
  active: PropTypes.bool,
  hover: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default SummaryCard
